module.exports = __webpack_public_path__ + "img/groupbishop-crop.76a00472.jpg";